import React from 'react';
const stats = [{
  value: '+500',
  label: 'profes confían',
  icon: '👥'
}, {
  value: '6+6',
  label: 'Tomos + Bonos',
  icon: '📚'
}, {
  value: '4.9/5',
  label: 'calificación',
  icon: '⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país',
  icon: ''
}];
const testimonials = [{
  initials: 'SM',
  quote: 'Organicé todo el año en una tarde. Nunca más llegué al salón sin saber qué dar ni cómo corregir.',
  name: 'Sebastián M.',
  location: 'Buenos Aires',
  role: 'Profesor Particular'
}, {
  initials: 'CR',
  quote: 'Los 80 guiones de corrección me cambiaron la forma de enseñar. Los alumnos resuelven errores en la misma clase.',
  name: 'Claudia R.',
  location: 'Rosario',
  role: 'Profesora en Academia'
}, {
  initials: 'DP',
  quote: "El sistema de musicalidad es único. Mis alumnos ahora bailan diferente con D'Arienzo que con Pugliese.",
  name: 'Diego P.',
  location: 'Córdoba',
  role: 'Profesor Independiente'
}];
export function SocialProofBar() {
  return <section className="w-full py-14 px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #1a1200 0%, #0d0b00 100%)'
  }} data-id="element-229">
      {/* Subtle ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[200px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(200,150,46,0.05) 0%, transparent 70%)'
    }} data-id="element-230" />

      <div className="relative max-w-5xl mx-auto" data-id="element-231">
        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-12" data-id="element-232">
          {stats.map(stat => <div key={stat.label} className="relative text-center py-4 px-2 rounded-xl bg-black/30 border border-[#C8962E]/10" data-id="element-233">
              <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-none mb-1.5" data-id="element-234">
                {stat.value}
              </div>
              <div className="text-[#C8962E] text-xs sm:text-sm font-semibold tracking-wide uppercase" data-id="element-235">
                {stat.icon && <span className="mr-1" data-id="element-236">{stat.icon}</span>}
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Divider */}
        <div className="w-20 h-[2px] bg-gradient-to-r from-transparent via-[#C8962E]/40 to-transparent mx-auto mb-10" data-id="element-237" />

        {/* Testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-238">
          {testimonials.map(t => <div key={t.initials} className="group relative bg-black/50 border border-[#C8962E]/15 rounded-2xl p-5 transition-colors hover:border-[#C8962E]/30" data-id="element-239">
              {/* Quote mark */}
              <div className="absolute top-3 right-4 text-[#C8962E]/10 text-4xl font-serif leading-none pointer-events-none" data-id="element-240">
                "
              </div>

              <div className="flex items-center gap-3 mb-3" data-id="element-241">
                <div className="w-9 h-9 rounded-full bg-[#C8962E]/15 border border-[#C8962E]/25 flex items-center justify-center text-[#C8962E] font-bold text-xs flex-shrink-0" data-id="element-242">
                  {t.initials}
                </div>
                <div data-id="element-243">
                  <div className="text-white font-bold text-sm leading-tight" data-id="element-244">
                    {t.name}
                  </div>
                  <div className="text-gray-500 text-[11px]" data-id="element-245">
                    📍 {t.location} · {t.role}
                  </div>
                </div>
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-2" data-id="element-246">
                "{t.quote}"
              </p>

              <div className="text-[#C8962E]/60 text-[10px] tracking-wider" data-id="element-247">
                ⭐⭐⭐⭐⭐
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}